import axios from "axios"
import { getUsersApi } from "../sharedData/userAPIs"
import { tokenConfig } from "../utils/apiConfig"

/**
 * @param {Function,Function}
 */
export async function getUsers(succCallbackFunc, errCallbackFunc) {
    await axios
        .get(getUsersApi, tokenConfig())
        .then(res => succCallbackFunc(res.data))
        .catch(err => {
            if (err instanceof String) { errCallbackFunc(err) }
            else { errCallbackFunc(JSON.stringify(err)) }
        })
}